import { Component, OnInit } from "@angular/core";
import { AuthenticationService } from "src/app/services/authentication.service";
import { PointService } from "src/app/services/point.service";
import { ProgramService } from "src/app/services/program.service";
import { ProposalService } from 'src/app/services/proposal.service';

@Component({
  selector: "app-admin-sidebar",
  templateUrl: "./admin-sidebar.component.html",
  styleUrls: ["./admin-sidebar.component.css"],
})
export class AdminSidebarComponent implements OnInit {
  public userProfile = null;
  public initial = "";
  point: "0";
  searchProduct = "";
  programList = [];
  isProgramEmpty = true;
  status: string;
  isB2bCustomer = true;
  isGT = false;
  isTOP = false;
  showMenuTagihan = true;
  totalProposal = 0;

  constructor(
    private authService: AuthenticationService,
    private pointService: PointService,
    private programService: ProgramService,
    private proposalService: ProposalService
  ) { }

  ngOnInit() {
    this.userProfile = this.authService.getObjUserProfile();

    const matches = this.userProfile.fullname.match(/\b(\w)/g);
    this.initial = matches.join("").substring(0, 2);

    this.loadPoint();
    this.loadProgram();
    this.getCountProposal();

    const gt = localStorage.getItem('gtStatus');
    if (gt === 'true') {
      this.isGT = true;
    }

    const top = localStorage.getItem('topStatus');
    if (top === 'true') {
      this.isTOP = true;
    }

    if (this.isGT) {
      if (this.isTOP) {
        this.showMenuTagihan = false;
      } else {
        this.showMenuTagihan = true;
      }
    } else {
      this.showMenuTagihan = true;
    }

    this.b2bCustomerStatus();
  }

  b2bCustomerStatus() {
    this.status = this.authService.getB2BStatus();

    if (this.status === "true") {
      this.isB2bCustomer = true;
    } else {
      this.isB2bCustomer = false;
    }
  }

  loadPoint(): void {
    this.pointService.getPoint(
      (data) => {
        this.point = data.point;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  public loadProgram() {
    this.programService.getProgram(
      this.searchProduct,
      (data) => {
        this.programList = data;

        if (this.programList.length === 0) {
          this.isProgramEmpty = true;
        } else if (this.programList.length != 0) {
          this.isProgramEmpty = false;
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getCountProposal() {
    this.proposalService.getCountProposal((count) => {
      this.totalProposal = count;
    });
  }
}